import { useQuery } from '@tanstack/react-query'
import { statistikApi } from '../lib/client'
import { ApiResponse, StatistikAgama } from '../../../shared-lib/types'

export function useAgamaStats() {
    return useQuery<ApiResponse<StatistikAgama>>({
        queryKey: ['statistik', 'agama'],
        queryFn: async () => {
            try {
                return await statistikApi.getAgama()
            } catch (error) {
                const errorResponse: ApiResponse<StatistikAgama> = {
                    status: "error",
                    message: error instanceof Error ? error.message : "Gagal mengambil data statistik agama",
                    data: {
                        totalPenduduk: 0,
                        agama: []
                    }
                }
                
                console.error('Error fetching agama statistics:', error)
                throw errorResponse
            }
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 3,
    })
}
